/* import __COLOCATED_TEMPLATE__ from './title.hbs'; */
/**

 ## Card Body

 The `sq-card/header/title` block component is designed to be used as a contextual component in: [sq-card](/components/glass/sq-card/header.html).

 **/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'h3',
  classNames: ['card__header__title'],
  title: null
});